exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cleanup-state button {\r\n  margin: .25rem;\r\n  white-space: normal;\r\n  max-width: 100%;\r\n}\r\n\r\n.content-recovery {\r\n  margin: 8px 0;\r\n  color: #495057;\r\n  font-size: 14px;\r\n}\r\n\r\n.content-recovery p {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.cleanup-standard {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  overflow-wrap: break-word;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/standard-assignment-cleanup/standard-assignment-cleanup.component.css
// module id = ../../../../../src/app/content-page/common/standard-assignment-cleanup/standard-assignment-cleanup.component.css
// module chunks = main